import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../SharedPage/Navbar";

const ProjectDetails = () => {
  return (
    <>
      <Navbar />
      <div
        data-aos="fade-right"
        data-aos-duration="2000"
        data-aos-delay="1000"
        className="min-h-screen py-10 bg-info"
      >
        <Outlet />
      </div>
    </>
  );
};

export default ProjectDetails;
